// extracted by mini-css-extract-plugin
export var errorIcon = "_mq-1";
export var nameLogo = "_mq-0";